<template>
  <div class="wrapper-content fadeInRight animated tabBox" id="rescureImportList-list">
      <div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
          <div class="form-horizontal pt10px">
            <div class="form-group">
              <label class="col-sm-1 control-label">保单号</label>
              <div class="col-sm-2">
                <input class="form-control" v-model.trim="queryParam.policyNo">
              </div>
              <label class="col-sm-1 control-label">被救援车牌</label>
              <div class="col-sm-2">
                <input class="form-control" v-model.trim="queryParam.rescuedPlateNumber">
              </div>   
              <label class="col-sm-1 control-label">客户电话</label>
              <div class="col-sm-2">
                <input class="form-control" v-model.trim="queryParam.rescuedPhone">
              </div>
              <label class="col-sm-1 control-label">救援类型</label>
              <div class="col-sm-2">
                <select class="form-control" v-model="queryParam.rescueType">
                  <option v-for="(option, index) in rescueTypeList" v-bind:value="option.udccode" :key="'rescueType' + index">
                    {{ option.udcname }}
                  </option>
                </select>
              </div>            
            </div>
            <div class="form-group">
              <label class="col-sm-1 control-label">请求开始时间</label>
              <div class="col-sm-2" v-bind:class="{ 'form-group--error': validDates }">
                <datepicker v-model="queryParam.requestStartTime" class="form-control" ref="startTime"></datepicker>
                <p v-if="validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
              </div>
              <label class="col-sm-1 control-label">请求结束时间</label>
              <div class="col-sm-2" v-bind:class="{ 'form-group--error': validDates }">
                <datepicker v-model="queryParam.requestEndTime" class="form-control" ref="endTime"></datepicker>
                <p v-if="validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
              </div>             
            </div>
            <div class="form-group">
              <div class="col-sm-12 text-right">
                <button type="button"  class="btn btn-primary" @click="searchInfo" :disabled="validDates">查询</button>
                <button type="button"  class="btn btn-primary" @click="resetQueryParams">重置</button>
              </div>
            </div>
            <div class="form-group">
              <div class="col-sm-12 text-right">
                <button type="button"  class="btn btn-primary" @click="createOrder">新建救援服务单</button>
                <button type="button"  class="btn btn-primary" @click="exporOrder">导出</button>
              </div>
            </div>           
          </div>
          <div class="location_table" style="overflow: hidden;width:100%; position: relative;">
            <div style="overflow: auto;">
              <table style="min-width:1600px;" class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>保单号</th>
                    <th>请求时间</th>
                    <th>救援类型</th>
                    <th>车牌号</th>
                    <th>客户电话</th>
                    <th>救援地址</th>
                    <th>录入时间</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(fileInfo,index) in orderList" v-bind:key="index">
                    <td>{{fileInfo.policyNo}}</td>
                    <td>{{fileInfo.requestTime}}</td>
                    <td>{{getResucureTypeStr(fileInfo.rescueType)}}</td>
                    <td>{{fileInfo.rescuedPlateNumber}}</td>
                    <td>{{fileInfo.rescuedPhone}}</td>
                    <td>{{fileInfo.rescuedAddress}}</td>
                    <td>{{fileInfo.entryTime}}</td>
                    <td class="text-center">
                      <a @click="itemDetail(fileInfo)">详情</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--分页组件开始-->
          <pagination v-if="orderList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>

          <tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
            {{messageStr}}
            <div slot="footer">
                  <button @click="closeModalMsg" class="btn btn-primary">确定</button>
              </div>
          </tab-modal>          
      </div>
  </div>   
</template>

<script>
import Datepicker from 'components/common/datepicker/Datepicker'
import { OPERATE_EXCEPTION } from 'static/message'
import Pagination from 'components/common/Pagination'
import {deepCopy} from 'util/util'
import TabModal from 'components/common/TabModal'
import classlist from 'util/classlist'
export default {
  name: '',
  props: [''],
  data () {
    return {
      loadingstatus: false,
      pageInfo: {},
      messageStr: '',
      scrollTop: '',
      queryParam: {
        policyNo: '',
        rescuedPlateNumber: '',
        rescuedPhone: '',
        rescueType: '',
        requestStartTime: '',
        requestEndTime: '',
        page_index: 1
      },
      orderList: [],
      rescueTypeList: [
        {
          udcname: '拖车',
          udccode: 1
        },
        {
          udcname: '搭电',
          udccode: 2
        },
        {
          udcname: '换胎',
          udccode: 3
        },
        {
          udcname: '送油',
          udccode: 4
        }
      ]	// 救援类型列表
    }
  },

  components: {Datepicker, TabModal, Pagination},

  computed: {
    // 起止时间是否合法
    validDates () {
      if (this.queryParam.requestStartTime && this.queryParam.requestEndTime) {
        return this.queryParam.requestStartTime > this.queryParam.requestEndTime
      } else {
        return false
      }
    },
    refreshCount () {
      return this.$store.state.global.refreshCount
    }
  },

  beforeMount () {
    this.getTableInfo()
  },

  mounted () {},

  methods: {
    getResucureTypeStr (type) {
      let str = ''
      this.rescueTypeList.forEach(element => {
        if (element.udccode == type) {
          str = element.udcname
        }
      })
      return str
    },
    // 从分页组件获取页码参数
    getPageNo (param) {
      this.queryParam.page_index = param
      this.getTableInfo()
    },
    createOrder () {
      const obj = {
        name: '新建救援录单',
        id: 'PageRescureImportEdit',
        route: '/indexhome/rescureImportEdit',
        No: 'rescureImportEdit',
        params: {mode: 'add', rescureList: this.rescueTypeList}
      }
      this.$router.push({path: '/indexhome/rescureImportEdit', query: obj.params})
      this.$store.dispatch('addTab', obj)
    },
    exporOrder () {
      console.log(this.orderList.length)
      if (this.orderList.length == 0) {
        this.openModalMsg('导出内容为空')
        return
      }
      let param = deepCopy(this.queryParam)
      delete param.page_index
      this.loadingstatus = true
      this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/entryOrders/export', {params: param, headers: this.token}).then(res => {
        if (res.body.success) {
          this.loadingstatus = false
          if (!res.body.data) return
          let str = res.body.data
          var path = process.env.EXPORT_PATH
          var api = process.env.API_ROOT
          var fileName = path + api + '/noauth/export?url=' + str
          var elemIF = document.createElement('iframe')
          elemIF.src = fileName
          elemIF.style.display = 'none'
          document.body.appendChild(elemIF)
        } else {
          this.openModalMsg(res.body.message)
          this.loadingstatus = false
        }
      }, res => {
        this.openModalMsg(res.body.message)
        this.loadingstatus = false
      }).catch(res => {
        this.openModalMsg(OPERATE_EXCEPTION)
        this.loadingstatus = false
      })
    },
    itemDetail (item) {
      const obj = {
        name: '救援录单详情',
        id: 'PageRescureImportEdit',
        route: '/indexhome/rescureImportEdit' + item.orderId,
        No: 'rescureImportEdit' + item.orderId,
        params: {mode: 'view', rescureList: this.rescueTypeList, id: item.orderId}
      }
      this.$router.push({path: '/indexhome/rescureImportEdit' + item.orderId, query: obj.params})
      this.$store.dispatch('addTab', obj)
    },
    searchInfo () {
      this.queryParam.page_index = 1
      this.getTableInfo()
    },
    resetQueryParams () {
      this.$refs.startTime.handleClear()
      this.$refs.endTime.handleClear()
      this.queryParam = {
        policyNo: '',
        rescuedPlateNumber: '',
        rescuedPhone: '',
        rescueType: '',
        requestStartTime: '',
        requestEndTime: '',
        page_index: 1
      }
    },
    getTableInfo () {
      let param = deepCopy(this.queryParam)
      if (param.requestEndTime == '') {
        delete param.requestEndTime
      }
      if (param.requestStartTime == '') {
        delete param.requestStartTime
      }
      this.loadingstatus = true
      this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/entryOrders', {params: param, headers: this.token}).then(res => {
        if (res.body.success) {
          this.loadingstatus = false
          if (!res.body.data) return
          const resInfo = res.body.data
          const {pageNum, pages, total, isFirstPage, isLastPage} = resInfo
          this.pageInfo = {
            pageNum: pageNum,
            pages: pages,
            total: total,
            isFirstPage: isFirstPage,
            isLastPage: isLastPage
          }
          this.orderList = resInfo.list
        } else {
          this.openModalMsg(res.body.message)
          this.loadingstatus = false
        }
      }, res => {
        this.openModalMsg(res.body.message)
        this.loadingstatus = false
      })
    },
    closeModalMsg () {
      this.closeModal('modalMsg')
    },
    openModalMsg (message) {
      this.messageStr = message
      this.openModal('modalMsg')
    },
    openModal (ref) {
      this.$refs[ref].open()
      classlist.toggleScroll('close', '#rescureImportList-list', this)
    },
    closeModal (ref) {
      this.$refs[ref].close()
      classlist.toggleScroll('open', '#rescureImportList-list', this)
    }
  },

  watch: {
    refreshCount (val) {
      console.log(val)
      this.getTableInfo()
    }
  }

}

</script>
<style lang='' scoped>

</style>



// WEBPACK FOOTER //
// PageRescureImportList.vue?7369eb2e